import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"><path fill-rule="evenodd" d="M10 2.5l-4.52 6L1 2.5h9z"/></svg>`;

export { symbol as default };
